<app-loader *ngIf="isLoading"></app-loader>
<div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
  <div>
    <h4 class="q-heading">
      <span><img src="../../../assets/images/backarrow.png" (click)="goBack()" alt=""
          class="me-2 cursor-pointer" /></span>
      {{ "MANAGEDEVICE.WIPEDEVICEDATA" | translate }}
    </h4>
  </div>
  <div class="ms-auto">
    <form [formGroup]="restorePublishForm">
      <select class="form-select bg-transparent" formControlName="mobileDeviceName"
        (change)="onMobileDeviceSelect($event)">
        <option *ngFor="let item of mobileDevice" [value]="item.id">
          {{ item.deviceName }}
        </option>
      </select>
    </form>
  </div>
</div>

<div class=" mb-5 mb-md-0"class="col-md-12 mb-3 commandsBG-WHITE text-center ">
  <div class="row">
    <div  >
      <img src="./assets/images/WIPEDEVICE.png" alt="" class="w-200" />
    </div>


      <div class="mt-4 list-unstyled">
        <li >
          <strong>{{ "MANAGEDEVICE.WipewillDELETE" | translate }}</strong>
        </li>
      </div>
      <div class="pb-1">
              <li>
              {{ "MANAGEDEVICE.WipewillDELETEFIRST" | translate }}
            </li>
          <div >
            <li>
            {{ "MANAGEDEVICE.WIPEWILLSECOND" | translate }}
          </li>
        
    </div>
          
      
    </div>
  </div>

  <div class="row mb-0 mb-md-5">
    <div class="col-md-12 mt-3 text-center">
      <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto" (click)="openLockModal()">
        {{ "MANAGEDEVICE.WIPEALLDATA" | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal mx-auto fade " id="LockPopup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
    <div class="modal-content border-none shadow-lg px-4 relative pointer-events-auto rounded-25 bg-white outline-none">
      <ng-container *ngIf="!isLock">
        <div class="mt-4">
          <img src="./assets/images/delete.svg" alt="" class="mx-auto" />
        </div>
        <h4 class="q-modal-heading mt-2 fw-bold">
          {{ "SUCESSMESSAGE.AREYOUSURE" | translate }}
        </h4>
        <p class="lightgray-clr text-sm">
          {{ "MANAGEDEVICE.WIPEALLDATAS" | translate }} {{deviceName}}
        </p>

        <ng-container *ngIf="errorMessage">
          <p class="errMessage" style="margin: 10px 90px">{{ errorMessage }}</p>
        </ng-container>
        <div class="text-center mb-4 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" (click)="sendCommand()">
              {{ "MANAGEDEVICE.WIPE" | translate }}
            </button>
          </div>
          <div class="">
            <button type="button" class="cancel-btn bg-cancelbtn" (click)="closeModal()">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isLock">
        <div class="mt-4">
          <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
        </div>
        <h5 class="q-modal-heading mt-4 deleteUser">
          {{ "SUCESSMESSAGE.DATADELETEDSUCCESSFULLY" | translate }}
        </h5>
        <div class="text-center">
          <div class="text-lg font-normal">
            <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>